// extracted by mini-css-extract-plugin
export default {"contactSplitSection":"ContactSplitSection_contactSplitSection__4G0Ij","w75":"ContactSplitSection_w75__KUtPs","border-end":"ContactSplitSection_border-end__mHPm8"};